import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import GraphViewer from "../../../../components/GraphPlotter/GraphViewer";
import FractionInput from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function buildTaskData() {
  const xRange = [-6, 6];
  const yRange = [-6, 6];

  for (let attempt = 0; attempt < 500; attempt++) {
    const zeroX = randInt(-5, 5);
    const aChoices = [-3, -2, -1, 1, 2, 3];
    const a = aChoices[randInt(0, aChoices.length - 1)];
    const b = -a * zeroX;

    if (Math.abs(b) > 5) continue;

    return {
      a,
      b,
      zeroX,
      xRange,
      yRange,
    };
  }

  return {
    a: 1,
    b: -2,
    zeroX: 2,
    xRange: [-6, 6],
    yRange: [-6, 6],
  };
}

export function generateTask() {
  return {
    type: "LinearZeroFromGraphTask",
    data: buildTaskData(),
  };
}

export function renderTask({ data }) {
  return (
    <div className="space-y-3">
      <p>
        Na wykresie przedstawiono funkcje liniowa <InlineMath math="f(x)" />.
        Odczytaj jej miejsce zerowe.
      </p>

      <div style={{ maxWidth: 360 }}>
        <GraphViewer
          width={360}
          equations={[`y = ${data.a}*x + (${data.b})`]}
          points={{}}
          segments={[]}
          xRange={data.xRange}
          yRange={data.yRange}
        />
      </div>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <div className="flex gap-4 items-center flex-wrap">
      <div className="flex items-center gap-2">
        <span><InlineMath math="x_0 = " /></span>
        <FractionInput
          value={userAnswer || ""}
          onChange={onChange}
          disabled={disabled}
          label="x_0"
        />
      </div>
    </div>
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  if (!Number.isFinite(userAnswer.parsed)) return false;
  return Math.abs(userAnswer.parsed - data.zeroX) < 0.005;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={`x_0 = ${userAnswer.raw}`} />;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`x_0 = ${data.zeroX}`} />;
}

export function renderExplanation({ data }) {
  return (
    <div className="space-y-2" style={{ textAlign: "left" }}>
      <p><strong>Krok 1:</strong> Miejsce zerowe to taki argument <InlineMath math="x_0" />, dla ktorego <InlineMath math="f(x_0)=0" />.</p>
      <p><strong>Krok 2:</strong> Na wykresie szukamy punktu przeciecia z osia <InlineMath math="OX" />.</p>
      <p><strong>Krok 3:</strong> Odczytujemy wspolrzedna <InlineMath math="x" /> tego punktu.</p>
      <BlockMath math={`x_0 = ${data.zeroX}`} />
    </div>
  );
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};



